<template>
  <div>
    <!-- <CCol xl="12" lg="12" md="12" style="margin-top: 20%" >
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol> -->
    <CCard style="margin-top: 20px">
      <CCardHeader>
        <div style="margin: auto">
          <DatePicker
            v-model="value1"
            type="date"
            range
            placeholder="Select date range"
            style="float: left"
          ></DatePicker>
        </div>
        <CButton
          color="success"
          style="margin-left: 15px"
          v-if="tbl2"
          @click="refresh()"
          >Go to all data</CButton
        >
        <!-- <JsonCSV
          v-if="tbl1"
          style="background-color: #4638c2; color: white; float: right"
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData"
          name="rage_capture-list.csv"
        >
          Download CSV (This is a slot)
        </JsonCSV> -->
        <JsonCSV
          v-if="tbl2"
          style="background-color: #4638c2; color: white; float: right"
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData2"
          name="rage_capture-list.csv"
        >
          Download CSV (This is a slot)
        </JsonCSV>
      </CCardHeader>

      <CCardBody>
        <CDataTable
          v-if="tbl1"
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
          <template #Choice="{ item }">
            <td>
              <p>{{ item.team1 }}</p>
              <p>{{ item.team2 }}</p>
              <p>Draw</p>
              <p><b>Total</b></p>
            </td>
          </template>
          <template #Bets="{ item }">
            <td>
              <p>{{ item.TeamOneusercount }}</p>
              <p>{{ item.TeamTwousercount }}</p>
              <p>{{ item.Drawusercount }}</p>
              <p>
                <b>{{ item.TotalUsercount }}</b>
              </p>
            </td>
          </template>
          <template #Amount="{ item }">
            <td>
              <p>{{ item.TeamOnetotalAmount }}</p>
              <p>{{ item.TeamTwototalAmount }}</p>
              <p>{{ item.DrawtotalAmount }}</p>
              <p>
                <b>{{ item.TotalBettingAmount }}</b>
              </p>
            </td>
          </template>
          <template #status="{ item }">
            <td v-if="item.endtime.seconds < todaydate.seconds">
              <a
                href="#"
                rel="noreferrer noopener"
                target="_blank"
                class="badge badge-warning ml-1"
              >
                completed
              </a>
            </td>
            <td v-else>
              <a
                href="#"
                rel="noreferrer noopener"
                target="_blank"
                class="badge badge-primary ml-1"
              >
                Live
              </a>
            </td>
          </template>
          <!-- <template #hash="{ item }">
            <td>
              {{ item.hash.substring(0, 10) + "..." }}
            </td>
          </template> -->
          <!-- <template #status="{ item }">
              <td>
                <span v-if="item.status=='success'">
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-success ml-1"
                  >
                    correct
                  </a></span
                >
                 <span v-if="item.status=='pending'">
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-warning ml-1"
                  >
                    pending
                  </a></span
                >
                 <span v-if="item.status=='wrong'">
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-danger ml-1"
                  >
                    wrong
                  </a></span
                >
                <span v-if="item.status=='Cancel'">
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-dark ml-1"
                  >
                    Cancel
                  </a></span
                >
              </td>
          </template> -->
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import firebase from "firebase";
const db = firebase.firestore();
import Swal from "sweetalert2";
import moment from "moment";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { secondaryDatabase } from "./secondary.js";
export default {
  components: {
    JsonCSV,
    DatePicker,
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
      tbl1: true,
      tbl2: false,
      Spinner: true,
      todaydate: null,
      tableData: [],
      userdata: [],
      tableData2: [],
      fields: [
        {
          label: "Match Id",
          key: "id",
          sortable: true,
        },
        {
          label: "Status",
          key: "status",
          sortable: true,
        },

        {
          label: "Match",
          key: "Match",
          sortable: true,
        },
        {
          label: "Answer",
          key: "Answer",
          sortable: true,
        },
        {
          label: "DeadLine",
          key: "EndDate",
          sortable: true,
        },
        // {
        //   label: "Quiz Status",
        //   key: "QuizStatus",
        //   sortable: true,
        // },

        // {
        //    label: "field4",
        //   key: "field4",
        //   sortable: true,
        // },
        {
          key: "Choice",
          sortable: true,
        },
        {
          label: "Token Name",
          key: "tokenName",
          sortable: true,
        },
        {
          key: "Bets",
          sortable: true,
        },
        {
          key: "Amount",
          sortable: true,
        },
        {
          key: "Bonus",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    value1() {
      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
      this.tableData = [];
      secondaryDatabase
        .collection("bettingtest")
        .where("endtime", ">=", v1)
        .where("endtime", "<=", v2)

        .get()
        .then((snapshot) => {
          this.tableData = [];
          snapshot.forEach((doc) => {
            this.Spinner = false;

            this.tableData.push({
              id: doc.id,
              team1: doc.data().team1,
              team2: doc.data().team2,
              // options: doc.data().options,
              // answer: doc.data().answer,
              status: doc.data().status == "TRUE" ? "Active" : "InActive",
              // image: doc.data().image,
              // quiztype: doc.data().quiztype,
              // starttime: doc.data().starttime,
              endtime: doc.data().endtime,
              // scramble: doc.data().scramble,
              // dfs: doc.data().dfs,
              Match: doc.data().team1 + " vs " + doc.data().team2,
              Answer: doc.data().answer != null ? doc.data().answer : 0,
              Created: moment(doc.data().quizdate.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),
              TeamOneusercount: doc.data().team1usercount,
              TeamTwousercount: doc.data().team2usercount,
              Drawusercount: doc.data().team3usercount,
              TotalUsercount: doc.data().usercount ? doc.data().usercount : 0,
              TeamOnetotalAmount: doc.data().team1totalAmount
                ? doc.data().team1totalAmount
                : 0,
              TeamTwototalAmount: doc.data().team2totalAmount
                ? doc.data().team2totalAmount
                : 0,
              DrawtotalAmount: doc.data().team3totalAmount
                ? doc.data().team3totalAmount
                : 0,

              TotalBettingAmount: doc.data().bettingamount,

              StartDate: moment(doc.data().starttime.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),
              EndDate: moment(doc.data().endtime.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),

              Bonus: doc.data().bonus ? doc.data().bonus : 0,
              tokenName: doc.data().tokenName,
            });
          });
        });
    },
  },
  methods: {
    refresh() {
      window.location.reload();
      // this.tbl1=true;
      //  this.tbl2=false;
    },

    getquiz() {
      var startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);
      var endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);
      secondaryDatabase
        .collection("bettingtest")
        .where("quizdate", ">=", startOfToday)
        .where("quizdate", "<=", endOfToday)
        .orderBy("quizdate", "desc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableData.push({
              id: doc.id,
              team1: doc.data().team1,
              team2: doc.data().team2,
              // options: doc.data().options,
              // answer: doc.data().answer,
              // status: doc.data().status == "TRUE"?"Active":"InActive",
              // image: doc.data().image,
              // quiztype: doc.data().quiztype,
              // starttime: doc.data().starttime,
              endtime: doc.data().endtime,
              // scramble: doc.data().scramble,
              // dfs: doc.data().dfs,
              Match: doc.data().team1 + " vs " + doc.data().team2,
              Answer:
                doc.data().answer != null ? doc.data().answer : "Not Answered",
              Created: moment(doc.data().quizdate * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),
              TeamOneusercount: doc.data().team1usercount
                ? doc.data().team1usercount
                : 0,
              TeamTwousercount: doc.data().team2usercount
                ? doc.data().team2usercount
                : 0,
              Drawusercount: doc.data().team3usercount
                ? doc.data().team3usercount
                : 0,
              TotalUsercount: doc.data().usercount ? doc.data().usercount : 0,
              TeamOnetotalAmount: doc.data().team1totalAmount
                ? doc.data().team1totalAmount
                : 0,
              TeamTwototalAmount: doc.data().team2totalAmount
                ? doc.data().team2totalAmount
                : 0,
              DrawtotalAmount: doc.data().team3totalAmount
                ? doc.data().team3totalAmount
                : 0,

              TotalBettingAmount: doc.data().bettingamount,

              StartDate: moment(doc.data().starttime.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),
              EndDate: moment(doc.data().endtime.seconds * 1000).format(
                "DD-MMM-YYYY , hh:mm:ss:a"
              ),
              Bonus: doc.data().bonus ? doc.data().bonus : 0,
              tokenName: doc.data().tokenName,
            });
          });
        });
    },

    rowClicked(item, index, column, e) {
      this.documentId = item.id;
    },

    deleteRoute(item) {
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("messagetest")
        .doc(this.documentId)
        .delete()
        .then(() => {
          this.getmessage();
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
    // sendmsg(){}
  },
  created() {
    this.getquiz();
    this.todaydate = firebase.firestore.Timestamp.fromDate(new Date());
    // this.sendmsg();
  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>